import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import * as ReactRouterRedux from 'react-router-redux';
import authReducer from '../auth/auth.reducer';
import businessReducer from '../business/business.reducer';
import { programsReducer, levelsReducer, programMemberReducer } from '../programs/Reducer';
import signupReducer from '../admin/signup.reducer';
import membersReducer from '../members/members.reducer';
import { payersReducer, payMethodsReducer } from '../billing/billing.reducer';
import { attendanceReducer, checkinReducer } from '../attendance/attendance.reducer';
import dashboardReducer from '../dashboard/dashboard.reducer';
import paymentsReducer from '../payments/Reducer';
import adminReducer from '../admin/admin.reducer';
import idleReducer from '../idle/Reducer';
import posReducer from '../pos/Reducer';
import packageReducer from 'src/mms-package/Reducer';
import { emailTemplateReducer, emailResultReducer } from '../emailTemplate/Reducer';

const config = {
  key: 'root',
  storage
};

const appReducer = persistCombineReducers(
  config,
  {
    authState: authReducer,
    adminState: adminReducer,
    signupState: signupReducer,
    businessState: businessReducer,
    programsState: programsReducer,
    levelsState: levelsReducer,
    membersState: membersReducer,
    payersState: payersReducer,
    payMethodsState: payMethodsReducer,
    attendanceState: attendanceReducer,
    checkinState: checkinReducer,
    dashboardState: dashboardReducer,
    paymentsState: paymentsReducer,
    idleState: idleReducer,
    posState: posReducer,
    programMemberState: programMemberReducer,
    packageState: packageReducer,
    emailTemplateState: emailTemplateReducer,
    emailResultState: emailResultReducer,
    router: ReactRouterRedux.routerReducer,
  }
);

export default appReducer;



// WEBPACK FOOTER //
// ./src/app/app.reducer.tsx